/* eslint-disable max-lines */
export var getComponentsColorsMapping = _ref => {
  var {
    neutral,
    info,
    success,
    warning,
    brand,
    critical,
    decorative,
    focus,
    link,
    avatar,
    illustration
  } = _ref;
  return {
    neutral,
    info,
    success,
    warning,
    brand,
    critical,
    decorative,
    focus,
    link,
    avatar,
    illustration,
    nakedButton: {
      secondary: {
        default: {
          color: brand.main
        },
        hover: {
          color: brand.dark
        },
        active: {
          color: brand.darkest
        }
      }
    }
  };
};
//# sourceMappingURL=components-colors-mapping.js.map